<template>
  <div id="app">
    <el-container class="main-container">
      <!-- 左侧工具栏 -->
      <el-aside class="sidebar">
        <h3>节点类型</h3>
        <el-button class="node-type-btn" type="primary" @click="addNode('start')">开始节点</el-button>
        <el-button class="node-type-btn" type="success" @click="addNode('approval')">审批节点</el-button>
        <el-button class="node-type-btn" type="warning" @click="addNode('condition')">条件节点</el-button>
        <el-button class="node-type-btn" type="danger" @click="addNode('end')">结束节点</el-button>

        <h3 style="margin-top: 30px;">流程管理</h3>
        <el-button type="primary" @click="saveFlow">保存流程</el-button>
        <el-button type="info" @click="loadFlow">加载流程</el-button>
        <el-button type="danger" @click="deleteSelected">删除选中</el-button>
      </el-aside>

      <!-- 画布区域 -->
      <el-main class="canvas-container">
        <div class="toolbar">
          <el-button size="small" @click="addConnection">添加连接</el-button>
          <el-button size="small" @click="clearCanvas">清空画布</el-button>
        </div>

        <!-- 连接线 -->
        <svg class="connections" width="100%" height="100%" preserveAspectRatio="none">
          <!-- 定义箭头标记 -->
          <defs>
            <marker id="arrow" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto" markerUnits="strokeWidth">
              <path d="M0,0 L0,6 L9,3 z" fill="#409eff" />
            </marker>
            
            <!-- 另一种箭头样式，用于流光效果 -->
            <marker id="arrow-flow" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto" markerUnits="strokeWidth">
              <path d="M0,0 L0,6 L9,3 z" fill="url(#gradient)" />
            </marker>

            <!-- 流光效果定义 -->
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#c0c4cc" stop-opacity="0.3" />
              <stop offset="50%" stop-color="#409eff" stop-opacity="1" />
              <stop offset="100%" stop-color="#c0c4cc" stop-opacity="0.3" />
            </linearGradient>

            <mask id="mask">
              <rect x="0" y="0" width="100%" height="100%" fill="white" />
            </mask>
          </defs>

          <!-- 普通连接线 -->
          <path
              v-for="(conn, index) in connections"
              :key="'conn_'+index"
              :d="getConnectionPath(conn)"
              class="connection"
              marker-end="url(#arrow)"
          />

          <!-- 流光效果连接线 -->
          <path
              v-for="(conn, index) in connections"
              :key="'flow_'+index"
              :d="getConnectionPath(conn)"
              class="flow-connection"
              marker-end="url(#arrow-flow)"
          >
            <animate
                attributeName="stroke-dashoffset"
                from="100"
                to="0"
                dur="1.5s"
                repeatCount="indefinite" />
          </path>
        </svg>

        <!-- 节点 -->
        <div
            v-for="(node, index) in nodes"
            :key="node.id"
            :ref="node.id"
            class="node"
            :class="node.type"
            :style="{ left: node.x + 'px', top: node.y + 'px' }
"
            @click="selectNode(node)"
            @mousedown="startDrag(node, $event)"
            @resize="updateNodeSize(node.id, $event.target.offsetWidth, $event.target.offsetHeight)"
        >
          <div class="node-header">{{ node.type.toUpperCase() }}</div>
          <div class="node-content">
            <div v-if="node.name">{{ node.name }}</div>
            <div v-else>未命名节点</div>
          </div>
        </div>

        <!-- 配置面板 -->
        <div v-if="selectedNode" class="config-panel">
          <h3>节点配置</h3>
          <el-form :model="selectedNode" label-width="80px">
            <el-form-item label="节点名称">
              <el-input v-model="selectedNode.name"></el-input>
            </el-form-item>

            <el-form-item label="节点类型">
              <el-select v-model="selectedNode.type" disabled>
                <el-option label="开始" value="start"></el-option>
                <el-option label="审批" value="approval"></el-option>
                <el-option label="条件" value="condition"></el-option>
                <el-option label="结束" value="end"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="描述" v-if="selectedNode.type !== 'start' && selectedNode.type !== 'end'">
              <el-input
                  type="textarea"
                  v-model="selectedNode.description"
                  :rows="3"
              ></el-input>
            </el-form-item>

            <el-form-item label="审批人" v-if="selectedNode.type === 'approval'">
              <el-input v-model="selectedNode.approver"></el-input>
            </el-form-item>

            <el-form-item label="条件组" v-if="selectedNode.type === 'condition'">
              <el-button size="mini" @click="addConditionGroup">添加条件组</el-button>
              <div
                  v-for="(group, groupIndex) in selectedNode.conditions || []"
                  :key="groupIndex"
                  style="margin-top: 10px; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px;"
              >
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <span>条件组 {{ groupIndex + 1 }}</span>
                  <el-button size="mini" type="text" @click="removeConditionGroup(groupIndex)">删除</el-button>
                </div>
                <div v-for="(condition, condIndex) in group.conditions" :key="condIndex" style="margin: 5px 0;">

                  <el-input
                      v-model="condition.field"
                      placeholder="字段名"
                      size="mini"
                  ></el-input>
                  <el-select v-model="condition.operator" size="mini" style="width: 80px; margin: 0 5px;">
                    <el-option label="=" value="eq"></el-option>
                    <el-option label=">" value="gt"></el-option>
                    <el-option label="<" value="lt"></el-option>
                    <el-option label=">=" value="gte"></el-option>
                    <el-option label="<=" value="lte"></el-option>
                    <el-option label="包含" value="contains"></el-option>
                  </el-select>
                  <el-input
                      v-model="condition.value"
                      placeholder="值"
                      size="mini"
                  ></el-input>
                  <el-button
                      size="mini"
                      type="text"
                      @click="removeCondition(groupIndex, condIndex)"
                  >删除</el-button>
                </div>

                <el-button size="mini" @click="addCondition(groupIndex)">添加条件</el-button>
                <div style="margin-top: 5px;">
                  连接方式:
                  <el-radio-group v-model="group.logic" size="mini">
                    <el-radio label="AND">AND(且)</el-radio>
                    <el-radio label="OR">OR(或)</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import requestTicket from "@/utils/requestTicket";

export default {
  name: "ApprovalWorkflow",
  data() {
    return {
      nodes: [],
      connections: [],
      selectedNode: null,
      draggingNode: null,
      dragOffsetX: 0,
      dragOffsetY: 0,
      isConnecting: false,
      connectionStartNode: null,
      canvasWidth: 2000,
      canvasHeight: 1200,
      nodeIdCounter: 1,
      connectionIdCounter: 1,
      nodeSizes: new Map(),
      workflowId: 1  // 添加一个默认的workflowId，实际应用中应该通过路由参数或其他方式获取
    }
  },
  mounted() {
    // 初始化画布
    this.canvasWidth = window.innerWidth * 2;
    this.canvasHeight = window.innerHeight * 2;
  },
  methods: {
    addNode(type) {
      const newNode = {
        id: 'node_' + this.nodeIdCounter++,
        type: type,
        x: Math.random() * 400 + 100,
        y: Math.random() * 300 + 100,
        name: type === 'start' ? '开始' :
            type === 'end' ? '结束' :
                type === 'approval' ? '审批节点' : '条件节点',
        description: '',
        approver: '',
        conditions: type === 'condition' ? [] : undefined
      };
      this.nodes.push(newNode);
    },
    selectNode(node) {
      if (this.isConnecting ) {
        if (this.connectionStartNode) {
          this.connections.push({
            from: this.connectionStartNode.id,
            to: node.id
          });
          this.connectionStartNode = null;
          this.isConnecting = false;
          this.$message.info('目标节点已选择');
        } else {
          this.connectionStartNode = node;
          this.$message.info('请点击目标节点');
        }
      } else {
        this.selectedNode = node;
      }
    },
    startDrag(node, event) {
      this.draggingNode = node;
      this.dragOffsetX = event.clientX - node.x;
      this.dragOffsetY = event.clientY - node.y;

      const onMouseMove = (e) => {
        if (this.draggingNode) {
          this.draggingNode.x = e.clientX - this.dragOffsetX;
          this.draggingNode.y = e.clientY - this.dragOffsetY;
        }
      };

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        this.draggingNode = null;
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    },
    addConnection() {
      this.isConnecting = true;
      this.$message.info('请先点击起始节点，然后点击目标节点');
    },
    updateNodeSize(nodeId, width, height) {
      this.nodeSizes.set(nodeId, { width, height });
    },

    getConnectionPath(conn) {
      const startNode = this.nodes.find(n => n.id === conn.from);
      const endNode = this.nodes.find(n => n.id === conn.to);

      if (!startNode || !endNode) return '';

      // 获取存储的节点尺寸或使用默认值
      const startSize = this.nodeSizes.get(startNode.id) || { width: 120, height: 60 };
      const endSize = this.nodeSizes.get(endNode.id) || { width: 120, height: 60 };

      // 计算中心点坐标
      const startX = startNode.x + startSize.width / 2;
      const startY = startNode.y + startSize.height / 2;
      const endX = endNode.x + endSize.width / 2;
      const endY = endNode.y + endSize.height / 2;

      // 创建直角连接线路径
      // 先从起点水平移动到中点，再垂直移动，最后水平移动到终点
      const midX = (startX + endX) / 2;
      return `M ${startX} ${startY} L ${midX} ${startY} L ${midX} ${endY} L ${endX} ${endY}`;
    },
    async saveFlow() {
      // 准备节点数据以匹配后端Node实体类
      const nodesData = this.nodes.map(node => {
        const nodeData = {
          nodeId: node.id,
          type: node.type,
          name: node.name,
          description: node.description || '',
          approver: node.approver || '',
          x: Math.round(node.x),
          y: Math.round(node.y)
        };
        
        // 如果是条件节点，添加条件信息
        if (node.type === 'condition' && node.conditions) {
          nodeData.conditions = node.conditions;
        }
        
        return nodeData;
      });

      // 准备连接数据以匹配后端Connection实体类
      const connectionsData = this.connections.map(conn => ({
        from: conn.from,
        to: conn.to
      }));

      const flowData = {
        nodes: nodesData,
        connections: connectionsData
      };

      try {
        // 修正API路径，去掉多余的/api前缀
        const response = await requestTicket.post(`/flow-config/${this.workflowId}`, flowData);

        if (response) {
          this.$message.success('流程已保存到服务器');
        } else {
          this.$message.error('保存失败');
        }
      } catch (error) {
        console.error('保存出错:', error);
        this.$message.error('保存过程中出现错误');
      }
    },
    
    async loadFlow() {
      try {
        // 修正API路径，去掉多余的/api前缀
        const response = await requestTicket.get(`/flow-config/${this.workflowId}`);
        
        if (response && response.data && response.data.nodes) {
          
          // 处理节点数据以适配前端显示
          this.nodes = (response.data.nodes || []).map(node => {
            const frontendNode = {
              id: node.nodeId,
              type: node.type,
              name: node.name,
              description: node.description,
              approver: node.approver,
              x: node.positionX,
              y: node.positionY
            };
            
            // 如果是条件节点且有配置信息，解析条件信息
            if (node.type === 'condition' && node.config) {
              try {
                frontendNode.conditions = JSON.parse(node.config);
              } catch (e) {
                console.error('解析条件配置出错:', e);
                frontendNode.conditions = [];
              }
            }
            
            return frontendNode;
          });
          
          // 处理连接数据以适配前端显示
          this.connections = (response.data.connections || []).map(conn => ({
            from: conn.fromNodeId,
            to: conn.toNodeId
          }));

          // 修改nodeIdCounter
          const maxId = Math.max(...this.nodes.map(n => {
            const num = parseInt(n.id.split('_')[1]);
            return isNaN(num) ? 0 : num;
          }), 0);
          this.nodeIdCounter = maxId + 1;
          this.$message.success('流程已从服务器加载');
        } else if (response && response.code === '404') {
          this.$message.warning('服务器上没有保存的流程数据');
        } else {
          this.$message.error('加载失败: ' + (response ? response.msg : '未知错误'));
        }
      } catch (error) {
        console.error('加载出错:', error);
        this.$message.error('加载过程中出现错误: ' + error.message);
      }
    },
    deleteSelected() {
      if (this.selectedNode) {
        // 删除节点及其连接
        this.nodes = this.nodes.filter(n => n.id !== this.selectedNode.id);
        this.connections = this.connections.filter(
            conn => conn.from !== this.selectedNode.id && conn.to !== this.selectedNode.id
        );
        this.selectedNode = null;
        this.$message.success('节点已删除');
      }
    },
    clearCanvas() {
      this.nodes = [];
      this.connections = [];
      this.selectedNode = null;
      this.$confirm('确定要清空整个画布吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('画布已清空');
      });
    },
    addConditionGroup() {
      console.log('selectedNode', this.selectedNode)
      if (this.selectedNode && this.selectedNode.type === 'condition') {
        if (!this.selectedNode.conditions) {
          this.$set(this.selectedNode, 'conditions', []);
        }
        this.selectedNode.conditions.push({
          logic: 'AND',
          conditions: []
        });
      }
    },
    removeConditionGroup(index) {
      if (this.selectedNode && this.selectedNode.type === 'condition') {
        this.selectedNode.conditions.splice(index, 1);
        this.$forceUpdate(); // 强制更新以确保视图刷新
      }
    },
    addCondition(groupIndex) {
      if (this.selectedNode && this.selectedNode.type === 'condition') {
        this.selectedNode.conditions[groupIndex].conditions.push({
          field: '',
          operator: 'eq',
          value: ''
        });
        this.$forceUpdate(); // 强制更新以确保视图刷新
      }
    },
    removeCondition(groupIndex, conditionIndex) {
      if (this.selectedNode && this.selectedNode.type === 'condition') {
        this.selectedNode.conditions[groupIndex].conditions.splice(conditionIndex, 1);
        this.$forceUpdate(); // 强制更新以确保视图刷新
      }
    }
  }
}
</script>

<style scoped>
.main-container {
  display: flex;
  height: 100vh;
}
.sidebar {
  width: 250px;
  background-color: #f5f7fa;
  padding: 20px;
  border-right: 1px solid #dcdfe6;
}
.canvas-container {
  flex: 1;
  position: relative;
  overflow: hidden;
}
.node {
  position: absolute;
  min-width: 120px;
  min-height: 60px;
  border: 2px solid #409eff;
  border-radius: 8px;
  background-color: #fff;
  cursor: move;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.node.start {
  background-color: #e6f7ff;
  border-color: #1890ff;
}
.node.approval {
  background-color: #f6ffed;
  border-color: #52c41a;
}
.node.condition {
  background-color: #fff7e6;
  border-color: #fa8c16;
}
.node.end {
  background-color: #ffe8e6;
  border-color: #ff4d4f;
}
.node-header {
  position: absolute;
  top: -25px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 12px;
  color: #606266;
}
.connections {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.connection {
  stroke: #409eff;
  stroke-width: 2;
  fill: none;
}
.flow-connection {
  stroke: url(#gradient);
  stroke-width: 3;
  fill: none;
  stroke-dasharray: 10;
  stroke-linecap: round;
}
.toolbar {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 100;
}
.config-panel {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 300px;
  background: white;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  max-height: 80vh;
  overflow-y: auto;
}
.node-type-btn {
  width: 100%;
  margin-bottom: 10px;
}
.node-content {
  padding: 20px 10px;
}
</style>